import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

export default function OrganicJourneyBanner() {
    const navigate = useNavigate();

    return (
        <section className="organic-banner">
            <motion.div
                className="organic-banner-inner"
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, ease: "easeOut" }}
                viewport={{ once: true }}
            >
                {/* LEFT CONTENT */}
                <div className="organic-text">
                    <span className="organic-tag">🌱 COMING SOON</span>

                    <h2>Our Organic Pulses Journey Begins</h2>

                    <p>
                        Chemical-free, responsibly sourced and naturally processed pulses —
                        crafted for a healthier tomorrow.
                    </p>

                    <div className="organic-pills">
                        <span>100% Natural</span>
                        <span>No Chemicals</span>
                        <span>Farm to Table</span>
                    </div>

                    {/* CTA */}
                    <button
                        className="organic-enquiry-btn"
                        onClick={() => navigate("/contact-us")}
                    >
                        Enquiry Now
                    </button>
                </div>

                {/* RIGHT IMAGE */}
                <div className="organic-image">
                    <img
                        src="/images/organic.png"
                        alt="Organic Pulses"
                    />
                </div>
            </motion.div>
        </section>
    );
}
